import React from 'react';
import { Wrapper } from '@crossroads/ui-components';
import { NavLink } from 'react-router-dom';
import styles from 'shop-views/CategoryNavigation.scss';

var CategoryNavigation = _ref => {
  var isActive = _ref.isActive,
      subCategories = _ref.subCategories;
  return subCategories.length > 0 && isActive && /*#__PURE__*/React.createElement(Wrapper, {
    className: styles.categoryNavigation
  }, /*#__PURE__*/React.createElement("ul", {
    className: styles.categoryNavigationList
  }, subCategories.map(x => /*#__PURE__*/React.createElement("li", {
    key: x.name,
    className: styles.categoryNavigationListItem
  }, /*#__PURE__*/React.createElement(NavLink, {
    activeClassName: styles.categoryNavigationListItemActive,
    to: {
      pathname: x.url,
      state: {
        hint: {
          type: "category",
          category: x
        }
      }
    }
  }, x.name)))));
};

export { CategoryNavigation };
//# sourceMappingURL=index.js.map
